type StatusBadgeVariant = 'outline' | 'success' | 'warning' | 'info' | 'destructive' | 'default';
type StatusBadgeIcon =
  | 'Clock'
  | 'ChefHat'
  | 'Package'
  | 'CheckCircle'
  | 'XCircle'
  | 'Calendar'
  | 'Clock'
  | 'Package';

type StatusBadge = {
  text: string;
  icon: StatusBadgeIcon;
  variant: StatusBadgeVariant;
};

export const STATUS_BADGE: Record<number, StatusBadge> = {
  1: { text: 'Aguardando aceite da loja', icon: 'Clock', variant: 'warning' },
  2: { text: 'Em preparo', icon: 'ChefHat', variant: 'warning' },
  3: { text: 'A caminho', icon: 'Package', variant: 'info' },
  5: { text: 'Pedido concluído', icon: 'CheckCircle', variant: 'success' },
  6: { text: 'Pedido cancelado', icon: 'XCircle', variant: 'destructive' },
  7: { text: 'Pronto para retirada', icon: 'Package', variant: 'success' },
  8: { text: 'Aguardando pagamento', icon: 'Clock', variant: 'warning' },
  9: { text: 'Erro no pagamento', icon: 'XCircle', variant: 'destructive' },
  10: { text: 'Pedido agendado', icon: 'Calendar', variant: 'outline' },
} as const;

export const STATUS_BADGE_FALLBACK = {
  text: 'Aguardando aceite da loja',
  icon: 'Clock',
  variant: 'outline',
} as const;
